import { Pipe, type PipeTransform } from '@angular/core';

import { type LeadershipTitle, leadershipTitleKey } from '../models/leadership-title';

/** `{{ member.leadershipTitle | leadershipTitleKey | translate }}` - a leadership title in the user's language. */
@Pipe({ name: 'leadershipTitleKey' })
export class LeadershipTitleKeyPipe implements PipeTransform {
  transform(title: LeadershipTitle | string | null | undefined): string {
    return leadershipTitleKey(title);
  }
}
